import React, { useLayoutEffect, useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Summary from '../../../../templates/thankyoulotto/Picker/Checkout/Summary';
import { formatCurrency } from '../../../../utils/formatters';
import { isDefault, isThankYouLotto } from '../../../../utils/template';
import { getNonEmptyLines } from '../../helpers/linesHelper';
import useLinesHelper from '../../helpers/useLinesHelper';

import { RootState } from '../../redux/store';

import MobileLine from './MobileLine';

function MobilePicker() {
    const { t } = useTranslation();
    const { lottery, lines, stakes, setLines, addEmptyLine, removeAllLines } = useLinesHelper();
    const { linePriceGross } = useSelector((state: RootState) => state.playStore);
    const isTemplateThankYouLotto = useMemo(() => isThankYouLotto(), []);

    useLayoutEffect(() => {
        const nonEmptyLines = getNonEmptyLines(lines);
        // add empty line if there is none and it does not exceed maxLinesPerTicket
        if (lines.length === nonEmptyLines.length && nonEmptyLines.length < lottery.maxLinesPerTicket) {
            addEmptyLine();
        }
        // remove empty lines if there are too many of them (specifically from desktop picker)
        if (lines.length > nonEmptyLines.length + 1) {
            setLines(nonEmptyLines);
        }
    }, [lines]);

    return (
        <div className={isTemplateThankYouLotto ? 'row align-items-start mt-4 row-gap-3' : 'form-mobile'}>
            {isDefault() && (
                <div className="message-box d-flex justify-content-between">
                    <span>
                        {t('playPicker.modal.selectedLines', {
                            linePrice: formatCurrency(linePriceGross, 2, lottery.currencyCode),
                            selectedCount: lines.length - 1,
                        })}
                    </span>
                    <span className="clear-all fw-bold text-decoration-underline" onClick={() => removeAllLines(lines)}>
                        {t('playPicker.clearAll')}
                    </span>
                </div>
            )}
            {lines.map((line, index) => (
                <MobileLine key={`${index + 1}`} lineNumbers={line} lineIndex={index} stake={stakes[index]} />
            ))}
            {isTemplateThankYouLotto && (
                <div className="col">
                    <Summary />
                </div>
            )}
        </div>
    );
}

export default MobilePicker;
